import * as React from 'react';
import { useStore } from 'zustand';
import { PredicateStoreContext } from '../context';

/**
 * Resets store values
 * @returns function | null
 */
export const usePredicateStoreReset = () => {
    const { store } = React.useContext(PredicateStoreContext);
    if (!store) throw new Error('Missing PredicateStoreContext.Provider in the tree');
    const reset = useStore(store, (s) => s.reset);

    return reset;
};
